import { ReactNode, Ref } from "react";
import { Heading } from "@otrium/atoms";
import { StickyTitleContainer } from "./StickyTitle.styled";
import { ResultsChip } from "../ResultsChip";

type StickyTitleProps = {
  title?: ReactNode;
  formattedTitle?: boolean;
  containerRef?: Ref<HTMLDivElement>;
};

function StickyTitle({
  title,
  formattedTitle,
  containerRef,
}: StickyTitleProps): JSX.Element | null {
  if (!title) return null;

  return (
    <StickyTitleContainer ref={containerRef}>
      <Heading
        as="h1"
        variant="h3"
        sx={{ wordBreak: "break-word" }}
        className={formattedTitle ? "formatted-title" : undefined}
      >
        {title}
      </Heading>
      <ResultsChip />
    </StickyTitleContainer>
  );
}

export { StickyTitle };
